import { ArticleHeading2, ArticleParagraph1, LinkButton, useDeviceType } from '@cian/ui-kit';
import * as style from './Failed.css';
import { clsx } from 'clsx';

interface IFailedProps {
  title: string;
  description: string;
}

export const Failed: React.FC<IFailedProps> = ({ title, description }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(clsx(style['container']), style[device])}>
      <div className={style['wrapper']}>
        <div className={style['image']} />
        <ArticleHeading2 textAlign="center">{title}</ArticleHeading2>
        <ArticleParagraph1 textAlign="center" color="theme-gray">
          {description}
        </ArticleParagraph1>
        <div className={style['btn']}>
          <LinkButton href="https://cian.ru/new-offer/" fullWidth>
            Разместить объявление
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
